import '.a{display:flex;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.be{gap:0.5rem;}.ssr-plugin'
import '.b9{cursor:pointer;}.ssr-plugin'
import '.h7{padding:0.75rem;}.ssr-plugin'
import '.ae{border-radius:1.25rem;}.ssr-plugin'
import '.bf{border:var(--blue-border);}.ssr-plugin'
import '.af{background-color:var(--shades-white);}.ssr-plugin'
import '.cl{transition:background-color 0.2s ease;}.ssr-plugin'
import '.d4{width:2.5rem;}.ssr-plugin'
import '.d5{height:2.5rem;}.ssr-plugin'
import '.h8{color:var(--shades-blue-700);}.ssr-plugin'
import '.h9{font-size:0.9rem;}.ssr-plugin'
import '.ar{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="a b e f be b9 h7 ae bf af cl"
        style={{
          '&:hover': {
            backgroundColor: 'var(--shades-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="d4 d5 a f b h8"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="h9 h8 ar"
        >
          {label}
        </span>
      </styled.button>
    )
}